module.exports = __webpack_public_path__ + "img/vertical_4_2_8023.0efb929e.png";